const Menu = [
    { path: "/dashboard", icon: "fa fa-home", title: "Dashboard", needAdmin: false },
    // { path: '/informes', icon: 'fa fa-chart-area', title: 'Informes' },
    {
        path: "/venta",
        icon: "fa fa-money-bill-alt",
        title: "Ventas",
        children: [
            { path: "/venta/registrar_factura", title: "Crear factura" },
            { path: "/venta/facturas_emitidas", title: "Facturas emitidas" },
            { path: "/venta/registro_cobros", title: "Registro de cobros" },
        ],
        needAdmin: false,
    },

    // { path: '/compra', icon: 'fa fa-briefcase', title: 'Compras',
    //   children: [
    //     { path: '/registrar_factura/compra', title: 'Registrar factura' },
    //     { path: '/compra/facturas_registradas', title: 'Facturas registradas' },
    //     { path: '/compra/registro_pagos', title: 'Registro de Pagos' },
    //   ]
    // },

    { path: "/terceros", icon: "fa fa-users", title: "Tercero", needAdmin: false },

    { path: "/usuarios", icon: "fa fa-user-check", title: "Usuarios", needAdmin: true },

    {
        path: "/parametros",
        icon: "fa fa-cog",
        title: "Parametros",
        children: [{ path: "/parametros/talonario", title: "Talonarios" }],
        needAdmin: true,
    },
];

export default Menu;
